import { render, staticRenderFns } from "./ProductAttributes.vue?vue&type=template&id=2c2c57bc&scoped=true&"
import script from "./ProductAttributes.vue?vue&type=script&lang=js&"
export * from "./ProductAttributes.vue?vue&type=script&lang=js&"
import style0 from "./ProductAttributes.vue?vue&type=style&index=0&id=2c2c57bc&scoped=true&lang=css&"
import style1 from "./ProductAttributes.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2c57bc",
  null
  
)

export default component.exports